export const ChargebacksQueueFields = {
	Id: {
		name: "id",
		displayName: "id",
		beName: "id",
	},
	AssignedTo: {
		name: "assignedTo",
		displayName: "Assigned To",
		beName: "assigned_to",
	},
	AssigneeId: {
		name: "assigneeId",
		displayName: "Assignee Id",
		beName: "assignee_id",
	},
	ChargebackTransactionsPercent: {
		name: "chargebackTransactionsPercent",
		displayName: "Chargebacks Trans, %",
		beName: "chargeback_transactions_percent",
	},
	ChargebackVolumePercent: {
		name: "chargebackVolumePercent",
		displayName: "Chargebacks Vol, %",
		beName: "chargeback_volume_percent",
	},
	ChargebacksAmount: {
		name: "chargebacksAmount",
		displayName: "Chargebacks Amount, $",
		beName: "chargebacks_amount",
	},
	ChargebacksCount: {
		name: "chargebacksCount",
		displayName: "Chargebacks Count",
		beName: "chargebacks_count",
	},
	MerchantId: {
		name: "merchantId",
		displayName: "Merchant Id",
		beName: "merchant_id",
	},
	MerchantName: {
		name: "merchantName",
		displayName: "Merchant Name (DBA)",
		beName: "merchant_name",
	},
	MerchantPriorityType: {
		name: "merchantPriorityType",
		displayName: "Merchant Priority Type",
		beName: "merchant_priority_type",
	},
	Mid: {
		name: "mid",
		displayName: "MID",
		beName: "mid",
	},
	ReviewType: {
		name: "reviewType",
		displayName: "Review Type",
		beName: "review_type",
	},
	SalesMonthlyVolume: {
		name: "salesMonthlyVolume",
		displayName: "Sales Monthly Volume, $",
		beName: "sales_monthly_volume",
	},
	TransactionsCount: {
		name: "transactionsCount",
		displayName: "Transactions Count",
		beName: "transactions_count",
	},
	ChargebacksAmountFrom: {
		name: "chargebacksAmountFrom",
		displayName: "Chargebacks Amount From",
		beName: "chargebacks_amount_from",
	},
	ChargebacksAmountTo: {
		name: "chargebacksAmountTo",
		displayName: "Chargebacks Amount To",
		beName: "chargebacks_amount_to",
	},
	ChargebacksCountFrom: {
		name: "chargebacksCountFrom",
		displayName: "Chargebacks Count From",
		beName: "chargebacks_count_from",
	},
	ChargebacksCountTo: {
		name: "chargebacksCountTo",
		displayName: "Chargebacks Count To",
		beName: "chargebacks_count_to",
	},
	SalesMonthlyVolumes: {
		name: "salesMonthlyVolumes",
		displayName: "Sales Monthly Volumes",
		beName: "sales_monthly_volumes",
	},
	MonthlyVolumesNumberFrom: {
		name: "monthlyVolumesNumberFrom",
		displayName: "Monthly Volumes From",
		beName: "sales_monthly_volume_from",
	},
	MonthlyVolumesNumberTo: {
		name: "monthlyVolumesNumberTo",
		displayName: "Monthly Volumes To",
		beName: "sales_monthly_volume_to",
	},
	TransactionsCountFrom: {
		name: "transactionsCountFrom",
		displayName: "Transactions Count From",
		beName: "transactions_count_from",
	},
	TransactionsCountTo: {
		name: "transactionsCountTo",
		displayName: "Transactions Count To",
		beName: "transactions_count_to",
	},
};
